export const MENU_ITEMS = [{
    name: 'Обучение',
    typeId: 1,
}, {
    name: 'Тема',
    typeId: 2,
}, {
    name: 'Тестове',
    typeId: 3,
}]